import React from 'react';
import {
    Box, Typography, CircularProgress, IconButton, Stack,
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import { dashboardPaperSx, dashboardInnerCardSx } from '../DashboardPanel';

const getFileExtension = (name) => {
    const parts = (name || '').split('.');
    return parts.length > 1 ? parts.pop().toUpperCase() : 'DOC';
};

const AsistentDocumentList = ({
    t,
    theme,
    documents,
    loading,
    deletingId,
    onDelete,
}) => (
    <Box sx={{ ...dashboardPaperSx(theme), p: 2.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
            {t('pages.asistent.documentsTitle')}
            {documents.length > 0 && (
                <Typography component="span" variant="caption" color="text.disabled" sx={{ ml: 0.75 }}>
                    ({documents.length})
                </Typography>
            )}
        </Typography>

        {loading ? (
            <Box sx={{ py: 3, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={28} />
            </Box>
        ) : documents.length === 0 ? (
            <Box
                sx={{
                    py: 4,
                    px: 2,
                    textAlign: 'center',
                    borderRadius: 2,
                    bgcolor: 'action.hover',
                    border: '1px dashed',
                    borderColor: 'divider',
                }}
            >
                <FolderOpenOutlinedIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
                <Typography variant="body2" color="text.secondary">
                    {t('pages.asistent.documentsEmpty')}
                </Typography>
            </Box>
        ) : (
            <Stack spacing={0.75}>
                {documents.map((doc) => {
                    const name = doc.source || doc.document_id;
                    const ext = getFileExtension(name);
                    return (
                        <Box key={doc.document_id} sx={(th) => dashboardInnerCardSx(th)}>
                            <Stack direction="row" alignItems="center" spacing={1.25}>
                                <Box
                                    sx={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: 1.5,
                                        bgcolor: 'primary.main',
                                        color: 'primary.contrastText',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        fontSize: '0.6rem',
                                        fontWeight: 700,
                                    }}
                                >
                                    {ext.slice(0, 4)}
                                </Box>
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Stack direction="row" spacing={0.75} alignItems="center">
                                        <DescriptionOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                                        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
                                            {name}
                                        </Typography>
                                    </Stack>
                                    <Typography variant="caption" color="text.secondary" noWrap>
                                        {doc.document_id}
                                    </Typography>
                                </Box>
                                <IconButton
                                    size="small"
                                    onClick={() => onDelete(doc.document_id)}
                                    disabled={deletingId === doc.document_id}
                                    sx={{ flexShrink: 0 }}
                                >
                                    {deletingId === doc.document_id
                                        ? <CircularProgress size={18} />
                                        : <DeleteOutlineIcon fontSize="small" />}
                                </IconButton>
                            </Stack>
                        </Box>
                    );
                })}
            </Stack>
        )}
    </Box>
);

export default AsistentDocumentList;
